import type { MigrationStrategies } from "./_types/migration-strategies";

export const CLINICAL_PRODUCT_CATEGORY_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
  };
